import React from 'react';

const Footer = () => {
    return (
        <div style={{backgroundColor: "#1f1f1f", height: "150px"}}>
        <p className="text-secondary text-center pt-5">Copyright section</p>
        </div>
    );
};

export default Footer;